import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import nodeinstance from "../../../../nodeInstance";
import UpdateDetailsPopUp from "./UpdateDetailsPopUp/UpdateDetailsPopUp";
import DocumentUploadFilePopUp from "../Iqama/FileDocumentPopUp/FileDocumentPopUp";
import { saveAs } from "file-saver";

export default function ListGRAjeer({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  var topTitles = [
    "S.NO.",
    "VISA PROVIDER",
    "CLIENT NAME",
    "EMPLOYEE COUNT",
    "SPONSOR ID 700",
    "AJEER STATUS",
  ];
  const [Details, SetDetails] = React.useState(false);
  const [Popup, setPopUp] = React.useState(false);
  const [PopupDoc, setPopUpDoc] = React.useState(false);
  const [listData, SetListData] = useState([]);
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const dispatch = useDispatch();
  const [itmeList, setItemList] = React.useState([]);
  const [ajeer_status_value, setAjeerStatus] = useState(0);
  const [newCurrentList, setNewCurrentList] = useState([]);
  const [ajeerStatusValue, setAjeerStatusValue] = useState("");

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(newCurrentList || []);

  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    SetListData((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      var list = Object.entries(checkedItems)
        .filter(([emp_id, isChecked]) => isChecked)
        .map(([emp_id]) => emp_id);

      if (list.length !== 0) {
        if (Details === false) {
          ajeerSentToClient({
            employee_id: list,
            ajeer_status: ajeerStatusValue,
          });
        } else {
          setPopUp(true);
        }
      } else {
        dispatch(
          setAppError({
            msg: "Please Select Vaild Emp",
          })
        );
      }
    }
  };

  const ajeerSentToClient = async (type) => {
    try {
      const res = await nodeinstance.post("/ajeer/updateAjeerStatus/", type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setCheckedItems({});
        callBack();
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.error,
        })
      );
    }
  };

  const callBack = () => {
    SetListData([]);
    updateData();
    setCheckedItems({});
    console.log(newCurrentList[0].ajeer_status_value);
    SetListData([]);
  };
  const [indexValue, setIndex] = useState(10);
  const [actionList, setActionList] = useState([]);

  const downlaodContractFiles = async () => {
    try {
      // Map employee IDs from listData
      const mappedData = listData.map((data) => ({
        employee_id: data.employee_id,
        contractfilepath: data.contractfilepath,
      }));

      console.log("data print in console", mappedData);
      // // Send request to the backend
      const response = await nodeinstance.post(
        "/ajeer/downloadContract",
        mappedData,
        {
          responseType: "blob", // Correct placement
          headers: {
            Authorization: `Bearer ${token}`, // Add token for authorization
          },
        }
      );

      if (response.status === 200) {
        console.log("Response received:", response.data);

        // Prepare file download
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // Create download link and trigger download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Employee_contract_${new Date()}.zip`); // Dynamic file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading contract files:", error);
      alert("Failed to download contract files. Please try again.");
    }
  };

  const [trigger, setTrigger] = useState(false);
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh]">
            <div className="sticky top-0 z-10 min-w-[1000px]">
              <div className="grid grid-cols-table-ajeer-applied gap-5 p-6 text-center">
                {topTitles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div>
              {!list?.data !== null
                ? list?.data?.listData.map((listData, index) => (
                    <a
                      key={index}
                      onClick={() => {
                        //
                        // { value: "Confirm" },
                        // { value: "Update Ajeer Details" },
                        // { value: "" },

                        if (listData.ajeer_status_value === 2) {
                          setActionList([{ value: "REQUEST SENT TO CLIENT" }]);
                        } else if (listData.ajeer_status_value === 5) {
                          setActionList([
                            { value: "Confirm" },
                            { value: "REQUEST SENT TO CLIENT" },
                          ]);
                        } else if (listData.ajeer_status_value === 7) {
                          setActionList([{ value: "Update Ajeer Details" }]);
                        } else if (listData.ajeer_status_value === 8) {
                          setActionList([]);
                        } else if (listData.ajeer_status_value === 9) {
                          setActionList([{ value: "Ajeer ISSUED" }]);
                        }
                        const filteredData = list.data.data.filter(
                          (indexData) =>
                            indexData.visa_provider ===
                              listData.visa_provider &&
                            indexData.client_name === listData.client_name &&
                            indexData.ajeer_status === listData.ajeer_status
                        );
                        setAjeerStatus(listData.ajeer_status_value);
                        setNewCurrentList(filteredData);
                        setIndex(index);
                        setCheckedItems({});
                      }}
                      className={`grid grid-cols-table-ajeer-applied auto-cols-min gap-5 p-4 text-center ${indexValue === index ? "bg-orange-50" : "bg-white"} rounded-md `}
                      style={{ cursor: "pointer" }} // Apply pointer cursor style
                    >
                      <React.Fragment key={index}>
                        <PaginationIndex index={index} />
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={listData.visa_provider || "-"}
                          />
                        </p>

                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={listData.client_name || "-"}
                          />
                        </p>

                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={
                              listData.employee_count.toString() || "-"
                            }
                          />
                        </p>
                        <p className="overflow-x-hidden">
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={listData.sponsor_id || "-"}
                          />
                        </p>
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={listData.ajeer_status || "-"}
                          />
                        </p>
                        {/* {indexValue === index ? <></> : <hr
                    className={`border-[1px] border-slate-100  w-full col-span-full `}
                  />} */}
                      </React.Fragment>
                    </a>
                  ))
                : ""}
            </div>
          </div>
        </div>

        {!list?.isLoading && currentList.length > 0 ? (
          <>
            <div className="flex space-x-2 ">
              <div className="gap-2 w-full items-center flex flex-row-reverse">
                <button
                  className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                  onClick={() => {
                    var list = Object.entries(checkedItems)
                      .filter(([emp_id, isChecked]) => isChecked)
                      .map(([emp_id]) => emp_id);
                    console.log(checkedItems.length);
                    if (list.length === 0) {
                      dispatch(
                        setAppError({
                          msg: "Please select Check box",
                        })
                      );
                    } else {
                      downlaodContractFiles();
                    }
                  }}
                >
                  <p>CONTRACT DOWNLOAD</p>
                </button>
                {newCurrentList[0].ajeer_status_value === 8 ? (
                  <button
                    className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                    onClick={() => setPopUpDoc(true)}
                  >
                    <p>UPLOAD BULK DOCUMENT</p>
                  </button>
                ) : (
                  <></>
                )}
                {newCurrentList[0].ajeer_status_value !== 8 ? (
                  <button
                    className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                    onClick={() => popOpen()}
                  >
                    <p>Update</p>
                  </button>
                ) : (
                  <></>
                )}
                {ajeer_status_value === 8 ? (
                  <></>
                ) : Object.entries(checkedItems)
                    .filter(([emp_id, isChecked]) => isChecked)
                    .map(([emp_id]) => emp_id).length !== 0 ? (
                  <div className="">
                    <select
                      className="select select-bordered select-sm w-full h-10"
                      defaultValue={{ label: "Choose", value: "placeholder" }}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        console.log(selectedValue);
                        if (selectedValue === "REQUEST SENT TO CLIENT") {
                          const data = itmeList.filter((indexData) =>
                            indexData.ajeer_status_value === null
                              ? ""
                              : indexData.ajeer_status_value.toString() === "2"
                          );
                          SetListData([...listData, data]);
                          setAjeerStatusValue("3");
                          SetDetails(false);
                        } else if (selectedValue === "Confirm") {
                          const data = itmeList.filter((indexData) =>
                            indexData.ajeer_status_value === null
                              ? ""
                              : indexData.ajeer_status_value.toString() === "5"
                          );
                          SetListData([...listData, data]);
                          setAjeerStatusValue("6");
                          SetDetails(false);
                        } else if (selectedValue === "Update Ajeer Details") {
                          const data = itmeList.filter((indexData) =>
                            indexData.ajeer_status_value === null
                              ? ""
                              : indexData.ajeer_status_value.toString() === "7"
                          );
                          SetListData([...listData, data]);
                          SetDetails(true);
                          setAjeerStatusValue("8");
                        } else if (selectedValue === "Ajeer ISSUED") {
                          const data = itmeList.filter((indexData) =>
                            indexData.ajeer_status_value === null
                              ? ""
                              : indexData.ajeer_status_value.toString() === "9"
                          );
                          SetListData([...listData, data]);
                          setAjeerStatusValue("10");
                          SetDetails(false);
                        } else {
                          setAjeerStatusValue("");
                          SetDetails(false);
                        }
                      }}
                    >
                      <option value="placeholder" hidden>
                        Choose
                      </option>
                      {actionList.map((value) => (
                        <option key={value.value} value={value.value}>
                          {value.value}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <></>
                )}

                <Search
                  searchKey={[
                    "employee_id",
                    "visa_reference_number",
                    "border_number",
                  ]}
                  setSearchWords={setSearchWords}
                />
              </div>
            </div>

            <div className={`flex flex-row w-full`}>
              <div
                className={`grid grid-cols-table-ajeer-details p-1 m-1 bg-blue rounded-md text-white w-96`}
              >
                <p>CLIENT</p>
                <p>{currentList[0].client_name}</p>
                <p>CR.NO </p>
                <p>{currentList[0].client_company_registration}</p>
                <p> MOL.NO </p>
                <p>{currentList[0].client_mobile}</p>
                <p>COMPANY SPONSOR ID (700 SERIES)</p>
                <p>{currentList[0].client_sponsor_id}</p>
              </div>
              <div
                className={`grid grid-cols-table-ajeer-details p-1 m-1 bg-blue rounded-md text-white w-96`}
              >
                <p>Visa Provider </p>
                <p>{currentList[0].visa_provider}</p>
                <p>CR.NO </p>
                <p>{currentList[0].visa_company_registration}</p>
                <p> MOL.NO </p>
                <p>{currentList[0].visa_mobile}</p>
                <p>COMPANY SPONSOR ID (700 SERIES)</p>
                <p>{currentList[0].visa_sponsor_id}</p>
              </div>{" "}
            </div>
            <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
            <CountPerPage />
            <div
              className={`grid grid-cols-table-grajeer auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
            >
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t == "ACTION" ? (
                    <div className="flex items-center mb-0  ">
                      <input
                        // disabled={list.ajeer_status_value.toString() === "2" || list.ajeer_status_value.toString() === "5" ? false : true}
                        key={list.employee_id}
                        type="checkbox"
                        checked={
                          checkedItems[currentList.map((e) => e.employee_id)] ||
                          false
                        }
                        onChange={(event) => {
                          currentList.map((list) =>
                            handleCheckboxChange(event, list.employee_id, list)
                          );
                        }}
                      />
                    </div>
                  ) : (
                    t
                  )}
                </p>
              ))}
              {list?.isLoading && <LoadingWithLable className="col-span-6" />}
              {!list?.isLoading && <NoDataFound />}

              {!list?.isLoading
                ? currentList?.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.client_name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.iqama_number || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_location_eng || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_location_ar || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_apply_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_issue_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_expiry_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_valid_days || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_fees || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={
                            list.ajeer_status_value === null
                              ? ""
                              : list.ajeer_status_value.toString() === "2"
                                ? "Pending"
                                : list.ajeer_status || "-"
                          }
                        />
                      </p>
                      <div className="flex items-center mb-0  ">
                        <input
                          key={list.employee_id}
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id, list)
                          }
                        />
                      </div>
                      <hr
                        className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))
                : ""}
            </div>
            <Pagination />
          </>
        ) : (
          <></>
        )}

        {Popup ? (
          <UpdateDetailsPopUp
            list={Object.entries(checkedItems)
              .filter(([emp_id, isChecked]) => isChecked)
              .map(([emp_id]) => emp_id)}
            PopUp={Popup}
            setPopUp={setPopUp}
            title={"Update Ajeer Details"}
            url={"/ajeer/updateDate/"}
            apiCall={callBack}
          />
        ) : (
          ""
        )}
        {PopupDoc ? (
          <DocumentUploadFilePopUp
            PopUp={PopupDoc}
            setPopUp={setPopUpDoc}
            title={"UPLOAD Bulk Documents"}
            url={`/ajeer/bulkuploadAjeerDoc`}
            callBack={callBack}
            fileFormat={"Ajeer-IQAMA NUMBER"}
            fileNme={"Ajeer-EmployeeID"}
            setTrigger={setTrigger}
            trigger={trigger}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
